import React from 'react'

const Exp = () => {
  return (
    <div className="exp">
      <img
        src="https://res.cloudinary.com/defcamc5x/image/upload/v1761321185/rfq1mm6cmqfp8u7kuqnj.png"
        alt=""
        className="dec"
      />
      <img
        src="https://res.cloudinary.com/defcamc5x/image/upload/v1761321185/rfq1mm6cmqfp8u7kuqnj.png"
        alt=""
        className="dec2"
      />
      <div className="mainTitle">
        <div className="lines">
          <div className="line"></div>
          <div className="line"></div>
          <div className="title">
            <h2>نتيجة اكثر من 21 عام من الخبرة القانونية</h2>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="mainContent">
          <div className="right">
            <div className="boxs">
              <div className="box">
                <span>50+</span>
                <p>تأسيس شركة</p>
              </div>
              <div className="box">
                <span>500+</span>
                <p>استشارة قانونية</p>
              </div>
              <div className="box">
                <span>200+</span>
                <p>قضية جنائية</p>
              </div>
              <div className="box">
                <span>400+</span>
                <p>قضية مدنية</p>
              </div>
              <div className="box">
                <span>1000+</span>
                <p>قضية أسرة</p>
              </div>
              <div className="box">
                <span>100+</span>
                <p>قضية تجارية</p>
              </div>
            </div>
          </div>
          <div className="left">
            <img
              src="https://res.cloudinary.com/defcamc5x/image/upload/v1761320205/pffozpsjsinbjmw6r6su.webp"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Exp